/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { ComponentChildren, FunctionComponent } from 'preact';
import { HTMLAttributes } from 'preact/compat';
import { classes } from '@adobe-commerce/elsie/lib';
import '@adobe-commerce/elsie/components/Card/Card.css';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'primary' | 'secondary';
  children: ComponentChildren | ComponentChildren[];
}

export const Card: FunctionComponent<CardProps> = ({
  variant = 'primary',
  className,
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      className={classes(['dropin-card', `dropin-card--${variant}`, className])}
    >
      <div class="dropin-card__content">{children}</div>
    </div>
  );
};
